// Vendors
import { ReactChildrenType } from '@gruposantander/opbpay-ui-core-models';
import React from 'react';
// Components
import { HeaderLayoutComponent } from 'components/header-layout/header-layout.component';
import { LoadingComponent } from 'components/loading/loading.component';
// Constants
import { APP_INFORMATION_PROVIDER_LOADING_PROPS } from 'providers/app-information/constants/app-information.constants';
// Hooks
import { useFeatureFlagsHook } from 'providers/feature-flags/hooks/feature-flags.hook';
// Styles
import { HeaderLayoutContentFullHeightStyled } from 'styles/app.styled';

const FeatureFlagsProvider = ({ children }: ReactChildrenType): React.ReactNode => {
  const { fetching } = useFeatureFlagsHook();

  return fetching ? (
    <HeaderLayoutComponent>
      <HeaderLayoutContentFullHeightStyled>
        <LoadingComponent {...{ ...APP_INFORMATION_PROVIDER_LOADING_PROPS, fetching }} />
      </HeaderLayoutContentFullHeightStyled>
    </HeaderLayoutComponent>
  ) : (
    children
  );
};

export { FeatureFlagsProvider };
